@let client = $client();
<unity-card-summary-shared>
  <h4>Remaining Amount</h4>
  <h3>
    @if ($isLoading()) {
      <kendo-skeleton [width]="30" />
    } @else {
      {{ client?.remaining_allocated_amount | currency }}
    }
  </h3>
  <kendo-gridlayout gap="0.5rem" [cols]="['1fr', '1em', '1fr']" [align]="{ horizontal: 'center', vertical: 'bottom' }">
    <kendo-gridlayout-item class="k-justify-self-end">
      <div class="k-text-center">
        <h6>Maximum Budget</h6>
        <h6>
          @if ($isLoading()) {
            <kendo-skeleton [width]="30" />
          } @else {
            {{ client?.allocated_amount | currency }}
          }
        </h6>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item>-</kendo-gridlayout-item>
    <kendo-gridlayout-item class="k-justify-self-start">
      <div class="k-text-center">
        <h6>Total Expensed</h6>
        <h6>
          @if ($isLoading()) {
            <kendo-skeleton [width]="30" />
          } @else {
            {{ client?.total_expensed_amount | currency }}
          }
        </h6>
      </div>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
</unity-card-summary-shared>
